import { NoteCommodityType, Question } from '@bechtel/sr-types';

export interface NotesProps {
  commodityId: string | undefined;
  commodityType: NoteCommodityType;
  primaryStatus: string | undefined;
  canAddEngineeringNote: boolean;
  canAddConstructionNote: boolean;
}

export interface SaveNotesFormikState {
  engineering?: string;
  construction?: string;
  cardRevisionQuestion?: Question;
}
export enum NotesModalTypes {
  EQUIPMENT_ENGINEERING = 'EQUIPMENT_NOTE_ENGINEERING',
  EQUIPMENT_CONSTRUCTION = 'EQUIPMENT_NOTE_CONSTRUCTION',
  RACEWAY_ENGINEERING = 'RACEWAY_NOTE_ENGINEERING',
  RACEWAY_CONSTRUCTION = 'RACEWAY_NOTE_CONSTRUCTION',
  JUMPER_ENGINEERING = 'JUMPER_NOTE_ENGINEERING',
  JUMPER_CONSTRUCTION = 'JUMPER_NOTE_CONSTRUCTION',
  CABLE_ENGINEERING = 'CABLE_NOTE_ENGINEERING',
  CABLE_CONSTRUCTION = 'CABLE_NOTE_CONSTRUCTION',
  CABLEFROMTERM_ENGINEERING = 'CABLE_FROM_TERM_NOTE_ENGINEERING',
  CABLEFROMTERM_CONSTRUCTION = 'CABLE_FROM_TERM_NOTE_CONSTRUCTION',
  CABLETOTERM_ENGINEERING = 'CABLE_TO_TERM_NOTE_ENGINEERING',
  CABLETOTERM_CONSTRUCTION = 'CABLE_TO_TERM_NOTE_CONSTRUCTION',
}
